import CornerGripperLogo from '../components/CornerGripperLogo';
import { HorizontalButtonPairView } from '../components/DRViewUtils';
import TimelineGraphic from '../components/TimelineGraphic';
import { confirmColor, confirmBorderColor, cancelColor } from '../constants/Styles';
import { joinCommaSeparatedNames } from './utils/composeText';

import './ConfirmRequestScreen.scss';

interface ConfirmRequestScreenProps {
  requester: string;
  note: string;
  pickups: string[];
  dropoffs: string[];
  clickCancel: () => void;
  clickConfirm: () => void;
  tapToReload: () => void;
  isRestricted: boolean;
  isLoading: boolean;
  isCodeRequired?: boolean;
}

export default function ConfirmRequestScreen(props: ConfirmRequestScreenProps) {
  const {
    requester,
    note,
    pickups,
    dropoffs,
    clickCancel,
    clickConfirm,
    tapToReload,
    isLoading,
    isRestricted,
    isCodeRequired,
  } = props;
  const buttonSettings = [
    {
      phrase: 'GO BACK',
      fillColor: 'transparent',
      borderColor: cancelColor,
      fontColor: cancelColor,
      action: clickCancel,
    },
    {
      phrase: 'CONFIRM',
      fillColor: confirmColor,
      borderColor: confirmBorderColor,
      fontColor: 'white',
      action: clickConfirm,
    },
  ];

  return (
    <>
      <div className="confirm-request-screen">
        <CornerGripperLogo tapToReload={tapToReload} />
        <div className="confirm-request-screen__content">
          <div className="content__title">
            <span className="content__title-text">
              Confirm{' '}
              {isRestricted ? (
                <span className="content__title-text--emph">
                  {isCodeRequired ? 'multi-factor' : 'restricted'}&nbsp;
                </span>
              ) : (
                ''
              )}
              delivery to <span className="content__title-text--emph">{joinCommaSeparatedNames(dropoffs)}</span>
            </span>
          </div>
          <div
            className={`content__details ${
              note === '' ? 'content__details--center-align' : 'content__details--left-align'
            }`}
          >
            {note === '' ? (
              <span className="details__text details__text--gray">No notes</span>
            ) : (
              <div>
                <div className="details__label">
                  <span className="details__label-text">Notes</span>
                  <div className="details__label-line" />
                </div>
                <span className="details__text details__text--black">{note}</span>
              </div>
            )}
          </div>
          <div className="content__graphic">
            <TimelineGraphic
              requester={requester}
              pickups={pickups}
              dropoffs={[joinCommaSeparatedNames(dropoffs)]}
              currentStopIndex={0}
              isRequest
            />
          </div>
          <div className="content__footer">
            Moxi will figure out an order for drop-offs for the fastest possible delivery.
            <br />
            Use notes on the previous screen to tell Moxi if there's an order you prefer.
          </div>
        </div>
        <div className="confirm-request-screen__footer">
          <HorizontalButtonPairView buttonSettings={buttonSettings} />
        </div>
      </div>
      {isLoading && <div className="loading-message">Requesting task, please wait...</div>}
    </>
  );
}

ConfirmRequestScreen.navigationOptions = {
  header: null,
};
